import { Component, Mixins } from "vue-property-decorator";
import SimulationMixin from "@/mixins/http/SimulationMixin";
import RequestsMixin from "@/mixins/http/RequestsMixin";

@Component
class SimulationService extends Mixins(SimulationMixin, RequestsMixin) {}

export default new SimulationService();
